import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ProductCategory } from '../types/product-category';
import { ProductCategoryActions } from './product-category.actions';

export interface ProductCategoryState extends EntityState<ProductCategory> {
  loading: boolean;
  error: any;
  totalElements: number;
  pageNumber: number;
  pageSize: number;
  saving: boolean;
  saveError: any;
}

export const productCategoryAdapter = createEntityAdapter<ProductCategory>({
  selectId: (entity) => entity.uuid,
});

const initialState: ProductCategoryState = productCategoryAdapter.getInitialState({
  loading: false,
  error: null,
  totalElements: 0,
  pageNumber: 0,
  pageSize: 10,
  saving: false,
  saveError: null,
});

export const productCategoryFeature = createFeature({
  name: 'productCategory',
  reducer: createReducer(
    initialState,
    on(ProductCategoryActions.loadPaginated, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(ProductCategoryActions.loadPaginatedSuccess, (state, { items, totalElements, number, size }) =>
      productCategoryAdapter.setAll(items, {
        ...state,
        loading: false,
        totalElements,
        pageNumber: number,
        pageSize: size,
      })
    ),
    on(ProductCategoryActions.loadPaginatedFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),

    on(ProductCategoryActions.save, (state) => ({
      ...state,
      saving: true,
      saveError: null,
    })),
    on(ProductCategoryActions.saveSuccess, (state, { item }) =>
      productCategoryAdapter.upsertOne(item, {
        ...state,
        saving: false,
        saveError: null,
      })
    ),
    on(ProductCategoryActions.saveFailure, (state, { error }) => ({
      ...state,
      saving: false,
      saveError: error,
    })),

    on(ProductCategoryActions.delete, (state) => ({
      ...state,
      loading: true,
    })),
    on(ProductCategoryActions.deleteSuccess, (state, { uuid }) =>
      productCategoryAdapter.removeOne(uuid, {
        ...state,
        loading: false,
        totalElements: state.totalElements - 1,
      })
    ),
    on(ProductCategoryActions.deleteFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }))
  ),
});

export const {
  selectAll: selectAllProductCategories,
  selectTotal: selectProductCategoriesTotal,
} = productCategoryAdapter.getSelectors(productCategoryFeature.selectProductCategoryState);
